import React from "react";
import {CART_TRACKING_PAGES} from '../_redux/files/cartRedux'
export function baseFilter(_entities, _queryParams, _filtrationFields = []) {
  // Filtration
  let entitiesResult = searchInArray(
    _entities,
    _queryParams.filter,
    _queryParams.filter_array_map,
    _filtrationFields
  );
  // Sorting
  // start
  if (_queryParams.sortField) {
    if (_queryParams.sortField === "POS_Standard") {
      entitiesResult = sortArray(entitiesResult, "sortOrder", "asc");
      entitiesResult = sortArray(entitiesResult, "active", "desc");
    } else {
      entitiesResult = sortArray(
        entitiesResult,
        _queryParams.sortField,
        _queryParams.sortOrder
      );
    }
  }
  // end

  // Paginator
  // start
  const pageNumber = _queryParams.pageNumber - 1;
  const totalCount = entitiesResult.length;
  const initialPos = pageNumber * _queryParams.pageSize;
  entitiesResult = entitiesResult.slice(
    initialPos,
    initialPos + _queryParams.pageSize
  );
  // end

  const queryResults = {
    entities: entitiesResult,
    totalCount: totalCount,
    errorMessage: "",
  };
  return queryResults;
}

/**
 * Sort array by field name and order-type
 * @param _incomingArray: any[]
 * @param _sortField: string
 * @param _sortOrder: string
 */
export function sortArray(_incomingArray, _sortField = "", _sortOrder = "asc") {
  if (!_sortField) {
    return _incomingArray;
  }

  let result = [];
  result = [..._incomingArray].sort((a, b) => {
    let aValue, bValue;
    if (_sortField.includes(".")) {
      const keys = _sortField.split(".");
      aValue = a[keys[0]][keys[1]];
      bValue = b[keys[0]][keys[1]];
    } else {
      aValue = a[_sortField];
      bValue = b[_sortField];
    }
    if (aValue < bValue) return _sortOrder === "asc" ? -1 : 1;
    else if (aValue > bValue) return _sortOrder === "asc" ? 1 : -1;
    else return 0;
  });
  return result;
}

/**
 * Filter array by some fields
 *
 * @param _incomingArray: any[]
 * @param _queryObj: any
 * @param _filtrationFields: string[]
 */
export function searchInArray(
  _incomingArray,
  _queryObj,
  _filter_array_map,
  _filtrationFields = []
) {
  const result = [];
  let resultBuffer = [];
  const indexes = [];
  let firstIndexes = [];
  let doSearch = false;

  //sub field not implemented yet in this
  _filtrationFields.forEach((item) => {
    if (item in _queryObj) {
      _incomingArray.forEach((element, index) => {
        if (element[item] === _queryObj[item]) {
          firstIndexes.push(index);
        }
      });
      firstIndexes.forEach((element) => {
        resultBuffer.push(_incomingArray[element]);
      });
      _incomingArray = resultBuffer.slice(0);
      resultBuffer = [].slice(0);
      firstIndexes = [].slice(0);
    }
  });

  Object.keys(_queryObj).forEach((key) => {
    if (typeof _queryObj[key] === "object") {
      Object.keys(_queryObj[key]).forEach((subkey) => {
        const searchText = _queryObj[key][subkey]
          .toString()
          .trim()
          .toLowerCase();
        if (
          key &&
          !_filtrationFields.some((e) => e[key] === subkey) &&
          searchText
        ) {
          doSearch = true;
          try {
            _incomingArray.forEach((element, index) => {
              if (
                element[key][subkey] ||
                (element[key][subkey] === 0 && searchText === "0")
              ) {
                const _val = element[key][subkey]
                  .toString()
                  .trim()
                  .toLowerCase();
                if (
                  _val.indexOf(searchText) > -1 &&
                  indexes.indexOf(index) === -1
                ) {
                  indexes.push(index);
                }
              }
            });
          } catch (ex) {
            console.error(ex, key + `[${subkey}]`, searchText);
          }
        }
      });
    } else {
      const searchText = _queryObj[key].toString().trim().toLowerCase();
      if (key && !_filtrationFields.some((e) => e === key) && searchText) {
        doSearch = true;
        try {
          _incomingArray.forEach((element, index) => {
            if (_filter_array_map.hasOwnProperty(key)) {
              const _val = _filter_array_map[key]
                .find((x) => x.value === element[key])
                ?.label.toString()
                .trim()
                .toLowerCase();
              if (_val || (_val === 0 && searchText === "0")) {
                if (
                  _val.indexOf(searchText) > -1 &&
                  indexes.indexOf(index) === -1
                ) {
                  indexes.push(index);
                }
              }
            } else {
              if (element[key] || (element[key] === 0 && searchText === "0")) {
                const _val = element[key].toString().trim().toLowerCase();
                if (
                  _val.indexOf(searchText) > -1 &&
                  indexes.indexOf(index) === -1
                ) {
                  indexes.push(index);
                }
              }
            }
          });
        } catch (ex) {
          console.error(ex, key, searchText);
        }
      }
    }
  });

  if (!doSearch) {
    return _incomingArray;
  }

  indexes.forEach((re) => {
    result.push(_incomingArray[re]);
  });

  return result;
}

export function sortByStandard(data) {
  let entitiesResult = sortArray(data, "sortOrder", "asc");
  entitiesResult = sortArray(entitiesResult, "active", "desc");
  return entitiesResult;
}

export function generateOptions({
  records,
  labelField,
  valueField,
  valueToBeSkipped = 0,
  withDisabled = "active",
  iconField = "",
}) {
  if (records && labelField && valueField) {
    return records.map((item) => ({
      label: iconField ? (
        <div>
          <img
            style={{ border: 0 }}
            src={item[iconField]}
            alt=""
            width="25px"
            height="25px"
          />{" "}
          {item[labelField]}
        </div>
      ) : (
        item[labelField]
      ),
      value: item[valueField],
      isDisabled:
        withDisabled && item[valueField] !== valueToBeSkipped
          ? !item[withDisabled]
          : false,
    }));
  } else {
    return records;
  }
}

export function errorMessageFormatter(data) {
  if (!data) return null;
  if (data.hasOwnProperty("errors")) {
    if (data.errors.length === 1) return data.errors[0];
    let message = "";
    for (let i = 0; i < data.errors.length; i++) {
      const error = data.errors[i];
      if (i === data.errors.length - 1) message = message + "and " + error;
      else message = message + error + ", ";
    }
  } else {
    if (data?.message?.includes("constrain")) {
      return "Somthing Went Wrong";
    } else {
      return data?.message;
    }
  }
}

export const formatDate = (date, format = "mm/dd/yyyy") => {
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let year = date.getFullYear();

  month = month >= 10 ? month : "0" + month;
  day = day >= 10 ? day : "0" + day;

  return format.replace("mm", month).replace("dd", day).replace("yyyy", year);
};

export const copyToClipboard = (str) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};


export const formatTime = (date, format = "hh:mm:ss") => {
  let hh = date.getHours()
  let mm = date.getMinutes()
  let ss = date.getSeconds()
  hh = hh < 10 ? '0' + hh : hh
  mm = mm < 10 ? '0' + mm : mm
  ss = ss < 10 ? '0' + ss : ss
  return format.toString().replace("hh", hh).replace('mm', mm).replace('ss', ss);

};
export const formatSelectedTime=(time)=>{
  let arr=time.split(":")
  let hh=arr[0];
  let minArr=arr[1].split(" ")
  if(minArr[1]==="PM"){
    if(Number(hh)!=12){
      hh=Number(hh)+12;
    }
  }
  return hh + ":" + minArr[0] + ":00 " 
}

export const formatDecimalTime = (time, format = "hh:mm") => {
  let decimalTimeString = time.toString();
  let decimalTime = parseFloat(decimalTimeString);
  decimalTime = decimalTime * 60 * 60;
  let hours = Math.floor(decimalTime / (60 * 60));
  decimalTime = decimalTime - hours * 60 * 60;
  let minutes = Math.floor(decimalTime / 60);
  decimalTime = decimalTime - minutes * 60;
  let seconds = Math.round(decimalTime);
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return format
    .replace("hh", hours)
    .replace("mm", minutes)
    .replace("ss", seconds);
};

export const calcTotalHours = (arrayOfTime) => {
  let hr = arrayOfTime.reduce(
    (a, b) => parseFloat(a ?? 0) + parseFloat(b.substring(0, 2) ?? 0),
    0
  );
  let mn = arrayOfTime.reduce(
    (a, b) => parseFloat(a ?? 0) + parseFloat(b.substring(3) ?? 0),
    0
  );
  hr += parseInt(mn / 60);
  mn = parseInt(mn % 60);
  hr = hr < 10 ? "0" + hr : hr;
  mn = mn < 10 ? "0" + mn : mn;
  return hr + ":" + mn;
};

export const exportToCsv = (cols, rows) => {
  const rowsToExport = [
    cols.map((x) => x.text),
    ...rows.map((row) => {
      let ab = [];
      cols.forEach((c) => {
        const format = (val) =>
          c.exportFormatter ? c.exportFormatter(val) : val;
        if (c.dataField.includes(".")) {
          let f = { ...row };
          c.dataField.split(".").forEach((fieldName) => {
            f = format(f[fieldName]);
          });
          ab.push((f ?? "").toString().replaceAll(",", " "));
        } else
          ab.push(
            (format(row[c.dataField]) ?? "").toString().replaceAll(",", " ")
          );
      });
      return ab;
    }),
  ];

  let csvContent =
    "data:text/csv;charset=utf-8," +
    rowsToExport.map((e) => e.join(",")).join("\n");
  var encodedUri = encodeURI(csvContent);
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  const locSplt = window.location.pathname.split("/");
  link.setAttribute(
    "download",
    locSplt[locSplt.length - 1] +
    "-" +
    new Date()
      .toLocaleString()
      .replaceAll("/", "-")
      .replaceAll(",", "-")
      .replaceAll(" ", "-")
      .replaceAll(":", "-") +
    ".csv"
  );
  // document.body.appendChild(link); // Required for FF

  link.click(); // This will download the data file named "my_data.csv".
};
export const emailData = (cols, rows) => {
  alert("Email Data");
};

export const formatABNNumber = (abn) => {
  const orgnl = abn.replaceAll(" ", "").split("");
  let newAbn = "";
  orgnl.forEach((c, i) => {
    if ([2, 4, 7, 10].includes(i)) {
      newAbn = newAbn + c + " ";
    } else newAbn += c;
  });
  return newAbn.toUpperCase();
};
export const formatContact = (contact) => {
  const orgnl = contact
    .replaceAll(" ", "")
    .replaceAll("(", "")
    .replaceAll(")", "")
    .split("");
  let newContact = "";
  orgnl.forEach((c, i) => {
    if (i === 2) {
      newContact = "(" + newContact + ") " + c;
    } else if (i === 6) {
      newContact = newContact + " " + c;
    } else newContact += c;
  });
  return newContact;
};
export const dayMap = [
  { label: "", value: 0 },
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
  { label: "Sunday", value: 7 },
];

export const addMinute = (time, minutes) => {
  return new Date(time.getTime() + minutes * 60000);
};
export const removeMinute = (time, minutes) => {
  return new Date(time.getTime() - minutes * 60000);
};
export const convertTimeToAMPM = (time) => {
  // Check correct time format and split into components
  time = time?.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];
  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
    time[0] = time[0] > 9 ? time[0] : "0" + time[0];
  }
  return time.join(""); // return adjusted time or original string
};
export const setTimeToDate = (date, time) => {
  var timeArr = time.split(":");
  if (timeArr?.length > 0) date.setHours(timeArr[0]);
  if (timeArr?.length > 1) date.setMinutes(timeArr[1]);
  if (timeArr?.length > 2) date.setSeconds(timeArr[2]);
  return date;
};

export const isMinuteMultipleOf = (time, num) => {
  return time.getMinutes() % num === 0
};
export const getMinuteMultipleOf = (time, num) => {
  while (!isMinuteMultipleOf(time, num)) {
    time = addMinute(time, 1);
  }
  return time;
}
export function isBlank(str) {
  return (!str || /^\s*$/.test(str));
}

export const letsRound = (number) => (Math.round(number * 100) / 100).toFixed(2)
export function letsPineappleRound(num) {
  const ns = parseFloat(num).toString().split('.')
  const dsmls = parseInt(ns[1] ?? 0).toString().substr(0, 2)
  const toBeRound = parseFloat(dsmls.split('')[0] + '.' + dsmls.split('')[1])
  const roundedDsmls = Math.round(toBeRound * 2) / 2.0;
  return ns[0] + '.' + roundedDsmls.toString().split('.').join('')
}
export const letsFloor = (number) => { 
  number = (Math.round(number * 100) / 100).toFixed(2);
  return parseFloat(number)
}


export const isValidEmail = (email) => {
  if (email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  return false
}
export const sortBySortOrderCol=(arr)=>{
  return [].slice.call(arr) .sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
}

export const sortObjectByKey=(unordered)=>{
  const ordered = Object.keys(unordered).sort().reduce(
    (obj, key) => { 
      obj[key] = unordered[key]; 
      return obj;
    }, 
    {}
  );
  return ordered
}
export const sortObjectByValue=(unordered)=>{
  const sortable = Object.entries(unordered)
    .sort(([,a],[,b]) => a?.group?.sortOrder-b?.group?.sortOrder)
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  return sortable
}
export const getIndexOf=(arr,item,key)=>{
  for (let i = 0; i < arr.length; i++) {
    let elem=arr[i];
    if(elem[key]===item[key]){
      return i;
    }
  }
  return -1;
}
export const resolveAfter2Seconds=()=> {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, 100);
});
}
export const wait = async()=>{
    await resolveAfter2Seconds();
}
export const isMobileDevice=()=> {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
export function GetActivePageName(){
  if(window.location.pathname.includes('/payment')){
    return CART_TRACKING_PAGES.payment;
  }else if(window.location.pathname.includes('/check-out')){
    return CART_TRACKING_PAGES["check-out"];
  }else{
    return CART_TRACKING_PAGES.default;
  }
}

export const defaultTimeDiffForClearingCart = 1200 //in seconds

export const makeMinOrderValueToTwoDecimal = (x) => {
  return Number.parseFloat(x).toFixed(2);
};


export const formatError = (err) => {
  if (typeof err === 'object' && err !== null) {
    return JSON.stringify({
      message: err.message,
      stack: err.stack,
      response: err.response ? err.response.data : null,
      name: err.name,
    }, null, 2); 
  }
  return String(err);
};